import { createTeamsChatLink } from './linkHelpers';
import { InterruptionDto, InterruptionListCardView } from '../../types';

const DEFAULT_TASK_STATUS_PING_MESSAGE = 'Please share a quick task status update.';

export const toInterruptionListCardView = (interruption: InterruptionDto): InterruptionListCardView => {
  const creatorEmail = interruption.context?.creatorEmail ?? '';
  const recipientEmail = interruption.context?.recipientEmail ?? '';
  const normalizedMessage = interruption.body?.trim() ?? '';

  return {
    id: interruption.id,
    type: interruption.type,
    creatorId: interruption.creatorId,
    creatorName: interruption.context?.creatorName || creatorEmail || 'Unknown user',
    recipientName: interruption.context?.recipientName || recipientEmail || '-',
    message: normalizedMessage || DEFAULT_TASK_STATUS_PING_MESSAGE,
    chatLink: createTeamsChatLink(creatorEmail),
  };
};
